<div class="summary-info">
  <div class="summary-header">
    <h2>{{ 'Summary information' | translate }}</h2>
    <button class="refresh-btn" (click)="refreshData()" [disabled]="loading">
      <img src="../../../assets/icons/main/light/restart-line.svg" alt="Refresh" />
    </button>
  </div>

  <div class="admin-content">
    <div class="info-cards">
      <div class="info-card">
        <div class="card-header">
          <span class="card-title">{{ 'Active / Blocked users for month' | translate }}</span>
        </div>
        <div class="card-header">
          <div class="card-value">{{ userStats.active }} / {{ userStats.blocked }}</div>
          <img src="../../../assets/icons/main/light/admin-user.svg" />
        </div>
        <div class="card-link-box">
          <button class="card-link" (click)="goToUserManagement()">{{ 'Details' | translate }}</button>
        </div>
      </div>

      <div class="info-card">
        <div class="card-header">
          <span class="card-title">{{ 'Number of user requests' | translate }}</span>
        </div>
        <div class="card-header">
          <div class="card-value">{{ appealsCount }}</div>
          <img src="../../../assets/icons/main/light/admin-user.svg" />
        </div>
        <div class="card-link-box">
          <button class="card-link" (click)="goToAppealsManagement()">{{ 'Details' | translate }}</button>
        </div>
      </div>

      <div class="info-card" [ngClass]="{'error-card': systemStatus?.overallStatus === 'error'}">
        <div class="card-header">
          <span class="card-title">{{ 'Number of errors' | translate }}</span>
        </div>
        <div class="card-header">
          <div class="card-value">
            <span *ngIf="loading">...</span>
            <span *ngIf="!loading && systemStatus">{{ systemStatus.modulesWithErrors }} / {{ systemStatus.totalErrors }}</span>
            <span *ngIf="!loading && !systemStatus">-</span>
          </div>
          <img [src]="systemStatus?.overallStatus === 'error' ? '../../../assets/icons/main/light/alert-fill.svg' : '../../../assets/icons/main/light/check-circle.svg'" />
        </div>
        <div class="card-link-box">
          <button class="card-link" (click)="goToSystemMonitoring()">{{ 'Details' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Compact System Status Panel -->
    <div class="compact-system-status">
      <div class="compact-header">
        <div class="status-title">
          <img src="../../../assets/icons/main/light/icon-pulse.svg" />
          <span>{{ 'System Status' | translate }}</span>
        </div>
        <button class="compact-details-btn" (click)="goToSystemMonitoring()">
          {{ 'Details' | translate }}
        </button>
      </div>

      <!-- Loading state -->
      <div *ngIf="loading" class="compact-loading">
        <div class="loading-spinner"></div>
        <span>{{ 'Loading...' | translate }}</span>
      </div>

      <!-- Error state -->
      <div *ngIf="error && !loading" class="compact-error">
        <img src="../../../assets/icons/main/light/alert-fill.svg" alt="Error" />
        <span>{{ error }}</span>
        <button class="retry-btn" (click)="refreshData()">{{ 'Retry' | translate }}</button>
      </div>

      <!-- Compact modules grid -->
      <div *ngIf="systemStatus && !loading && !error" class="compact-modules-grid">
        <div *ngFor="let module of systemStatus.modules" 
             class="compact-module-item" 
             [ngClass]="getStatusClass(module.status)"
             [title]="getModuleDisplayName(module)">
          <div class="module-indicator">
            <div class="status-dot" [ngClass]="getStatusClass(module.status)"></div>
            <span class="module-name" [pTooltip]="getModuleDisplayName(module)" tooltipPosition="top">
              {{ truncateText(getModuleDisplayName(module)) }}
            </span>
          </div>
          <div class="module-stats">
            <div class="error-indicator" *ngIf="module.errorCount > 0">
              <img src="../../../assets/icons/main/light/alert-fill.svg" alt="Error" />
              <span class="error-count">{{ module.errorCount }}</span>
            </div>
            <div class="success-indicator" *ngIf="module.errorCount === 0">
              <img src="../../../assets/icons/main/light/check-circle.svg" alt="Success" />
            </div>
          </div>
        </div>

        <!-- Empty state -->
        <div *ngIf="systemStatus.modules.length === 0" class="compact-empty">
          <span>{{ 'No modules found' | translate }}</span>
        </div>
      </div>

      <!-- Overall status summary -->
      <div class="compact-summary" *ngIf="systemStatus && !loading && !error">
        <div class="summary-stats">
          <div class="stat-item">
            <span class="stat-label">{{ 'Total Modules' | translate }}</span>
            <span class="stat-value">{{ systemStatus.modules.length }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ 'With Errors' | translate }}</span>
            <span class="stat-value error">{{ systemStatus.modulesWithErrors }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ 'Total Errors' | translate }}</span>
            <span class="stat-value error">{{ systemStatus.totalErrors }}</span>
          </div>
        </div>
        <div class="overall-indicator" [ngClass]="getStatusClass(systemStatus.overallStatus)">
          <img [src]="getStatusIcon(systemStatus.overallStatus)" alt="">
          <span>{{ getStatusText(systemStatus.overallStatus) | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>